import { UserFormQuestion } from '@hiwaldo/sdk/interfaces';

export interface UserFormQuestionState {
  data: UserFormQuestion;
  loading?: boolean;
  error?: string;
}

const initialUserFormQuestion = {
  id: 1,
  title: 'Partner Contact Reasons',
  questionType: 'MULTIPLE_CHOICE',
  phrase:
    'Select up to four of the options below in order for us to contact you with relevant information:',
  choices: [
    { id: 1, phrase: 'Become a Doctor Partner' },
    { id: 2, phrase: 'Become a Doctor Ambassador' },
    { id: 3, phrase: 'Ship me a fitting set' },
    { id: 4, phrase: 'General Inquiry' },
  ],
};

export const initialUserFormQuestionState: UserFormQuestionState = {
  data: initialUserFormQuestion as UserFormQuestion,
  error: '',
  loading: false,
};
